import React, {Component} from 'react';


import "./App.css"

class Impressum extends Component {
	UNSAFE_componentWillMount(){
		window.scrollTo(0,0);
	}

render() {
  return (
  
	  <div className="impressumApp">
		<h1>Impressum</h1>
		<br/>
		<p className="content4">

			Konrad Ober<br/>
			8698 Pamuk<br/>
			Ungarn<br/>	<br/>		
			
		</p>
	

		




	
	  </div>

  );
};
};


export default Impressum;
